import React from "react";

import ProductGridBelow from "./ProductGridBelow";
import ProductGridHealth from "./ProductGridHealth";

const LastFourServices = ({ handleCardClick }) => {
  return (
    <div className="row mb-2">
          <div className="col-12 mb-3">
        <div
          onClick={() => handleCardClick("API_THS", "healthadvisory")}
          style={{ cursor: "pointer" }}
        >
          <ProductGridHealth
          image="/images/health-advisory.png"
          title="Health Advisory"
          />
        </div>
      </div>
      <div className="col-4">
        <div
          onClick={() => handleCardClick("API_VS", "veterinaryadvisory")}
          style={{ cursor: "pointer" }}
        >
          <ProductGridBelow
            image="/images/veterinary.png"
            title="Veterinary Advisory"
          />
        </div>
      </div>
      <div className="col-4">
        <div
          onClick={() => handleCardClick("API_AS", "agronomi")}
          style={{ cursor: "pointer" }}
        >
          <ProductGridBelow
            image="/images/agronomi.png"
            title="Agro Nomi Advisory"
          />
        </div>
      </div>
    
      <div className="col-4 ">
        <div
          onClick={() => handleCardClick("API_LS", "legaladvisory")}
          style={{ cursor: "pointer" }}
        >
          <ProductGridBelow
            image="/images/lifelegal.png"
                title="Legal Advisory"
          />
        </div>
      </div>
    </div>
  );
};

export default LastFourServices;
